import { ConfirmationDialog } from "components";
import { connect, useSelector } from "react-redux";
import { deleteQuestions } from "../store/action";
import { useEffect, useState } from "react";

interface OwbProps {
  questionId: string;
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwbProps;
const HandleDeleteQuestion:React.FC<Props> = ({ questionId, onDeleteQuestion, closeModal}) =>{
   const videoDetailsState = useSelector(
    (state: any) => state.videoDetails?.genericVideoDetailsState
  );
  const [deleteError, setDeleteError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const handleDeleteVideo = (e: any) => {
    e.stopPropagation();
    onDeleteQuestion(questionId.toString());
    setSubmitted(true);
  };
  useEffect(() => {
    if (submitted) {
      setDeleteError(videoDetailsState?.error);
      if (videoDetailsState?.delete) {
        closeModal(false);
      } else if (videoDetailsState.error) {
        closeModal(true);
      }
    }
  }, [videoDetailsState?.delete, submitted]);
  return (
    <>
      <ConfirmationDialog
        title={"Delete Video"}
        message={"Are you sure you want to delete?"}
        onConfirm={handleDeleteVideo}
        onCancel={() => closeModal(false)}
        error={deleteError}
      />
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onDeleteQuestion: (questionId: string) => dispatch(deleteQuestions(questionId)),
});

export default connect(null, mapDispatchToProps)(HandleDeleteQuestion);